import { useRadiologyWorklist } from './pathology.queries';
import { departmentReportStatusOptions } from './pathology.utils';
import { WorklistPage } from './WorklistPage';

export const RadiologyPage = () => (
  <WorklistPage
    eyebrow="Investigation"
    title="Radiology"
    description="Imaging studies awaiting a report."
    useWorklist={useRadiologyWorklist}
    actionLabel="Generate"
    action="mark-ready"
    emptyTitle="No pending radiology studies"
    emptyMessage="Tests tagged Radiology in Settings > Charges will appear here until their report is generated."
    showReportUpdate
    reportUpdateBulk={false}
    statusOptions={departmentReportStatusOptions}
    defaultStatus="all"
  />
);
